export const SHOW_ALERT_FLAG = "SHOW_ALERT_FLAG"
export const DISABLE_ALERT_FLAG="DISABLE_ALERT_FLAG"

